import React, { Component } from "react";
export default class CountDown extends Component {
  state = {
    time: {},
    countDown: null,
  };
  handleCountDown = (seconds) => {
    var secs = seconds;
    const countDown = setInterval(() => {
      const date = new Date(secs * 1000);
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      const day = (secs / 86400).toString().split(".")[0];
      if (secs > 0) {
        secs--;
        this.setState({ time: { day, hour, minute, second } });
      } else {
        clearInterval(countDown);
      }
    }, 1000);
    this.setState({ timer: countDown });
  };
  componentDidMount() {
    this.handleCountDown(this.props.expire_time);
  }
  componentWillUnmount() {
    clearInterval(this.state.countDown);
  }
  render() {
    return (
      <div className={"lottery"}>
        <div className={"counter"}>
          <div className={"hourMinuteSecond"}>
            <div className={"part"}>
              <span className={"value"}>{this.state.time.second}</span>
            </div>
            <div className={"part"}>
              <span className={"value"}>: {this.state.time.minute} :</span>
            </div>
            <div className={"part"}>
              <span className={"value"}>{this.state.time.hour}</span>
            </div>
          </div>
          <div className={"day"}>
            <div className={"part"}>
              <span className={"value"}>{this.state.time.day}</span>
              {this.state.time.day ? <>روز</> : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

